import { render, staticRenderFns } from "./CollaboratorCreateModal.vue?vue&type=template&id=7a69126f"
import script from "./CollaboratorCreateModal.vue?vue&type=script&lang=js"
export * from "./CollaboratorCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorCreateModal.vue?vue&type=style&index=0&id=7a69126f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports